import { render, staticRenderFns } from "./dyDetails.vue?vue&type=template&id=4215d469&scoped=true"
import script from "./dyDetails.vue?vue&type=script&lang=js"
export * from "./dyDetails.vue?vue&type=script&lang=js"
import style0 from "./dyDetails.vue?vue&type=style&index=0&id=4215d469&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215d469",
  null
  
)

export default component.exports